(function () {
  const SECTION_SELECTOR = '.section-page-type-tabs';

  function initStickyTabsOffset(section) {
    // `section` is the .shopify-section wrapper — that's the element that sticks.
    const tabsBar = section;
    if (!tabsBar) return;

    const header = document.querySelector('.section-header.shopify-section-group-header-group');

    const getPromoBannerHeight = () => {
      const promoBar = document.querySelector('.promo-bar-wrapper');
      if (!promoBar) return 0;
      const rect = promoBar.getBoundingClientRect();
      const isVisible = rect.height > 0 && window.getComputedStyle(promoBar).display !== 'none';
      return isVisible ? Math.round(rect.height) : 0;
    };

    const getTickerHeight = () => {
      const ticker = document.querySelector('ticker-bar');
      if (!ticker) return 0;
      const rect = ticker.getBoundingClientRect();
      const isVisible = rect.height > 0 && window.getComputedStyle(ticker).display !== 'none';
      return isVisible ? Math.round(rect.height) : 0;
    };

    const updateStickyOffset = () => {
      const promoBannerHeight = getPromoBannerHeight();
      const tickerHeight = getTickerHeight();
      const fixedTopHeight = Math.max(promoBannerHeight, tickerHeight);
      let headerVisibleHeight = 0;
      if (header) {
        const rect = header.getBoundingClientRect();
        const visibleBottom = Math.min(rect.bottom, window.innerHeight);
        const visibleTop = Math.max(rect.top, 0);
        headerVisibleHeight = Math.max(0, visibleBottom - Math.max(visibleTop, fixedTopHeight));
      }
      const stickyTop = Math.round(fixedTopHeight + headerVisibleHeight);
      tabsBar.style.setProperty('--ptt-sticky-top', `${stickyTop}px`);

      // Collapse only once the wrapper's top edge reaches the very top of the viewport,
      // and restore when scrolled back to the very top of the page.
      const isStuck = window.scrollY > 0 && tabsBar.getBoundingClientRect().top <= stickyTop;
      tabsBar.classList.toggle('is-stuck', isStuck);
    };

    let rafId = null;
    const scheduleUpdate = () => {
      if (rafId !== null) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = null;
        updateStickyOffset();
      });
    };

    updateStickyOffset();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      initStickyTabsOffset(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector
      ? event.target.querySelector(SECTION_SELECTOR) || (event.target.matches(SECTION_SELECTOR) ? event.target : null)
      : null;
    if (section) initStickyTabsOffset(section);
  });
})();
